import { render, staticRenderFns } from "./InputnumberProp.vue?vue&type=template&id=12171264&"
import script from "./InputnumberProp.vue?vue&type=script&lang=js&"
export * from "./InputnumberProp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports